import React, { useCallback } from 'react';
import { TextField } from '@mui/material';
import { onlyDigits } from '../../utils/phone';
import { colors } from '../../theme/tokens';

/**
 * Campo do código SMS.
 *
 * Reproduz o input único do legado (6 dígitos, centralizado, monoespaçado e
 * com `letter-spacing` largo), mas com filtragem de dígitos e suporte a colar
 * o código inteiro.
 */

export const OTP_LENGTH = 6;

interface OtpInputProps {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
  error?: string | null;
  label: string;
  /** Vem do dicionário (invariante 9): nenhuma string visível nasce aqui. */
  placeholder: string;
}

export function OtpInput({
  value,
  onChange,
  onComplete,
  error,
  label,
  placeholder,
}: OtpInputProps) {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const digits = onlyDigits(event.target.value).slice(0, OTP_LENGTH);
      onChange(digits);
      if (digits.length === OTP_LENGTH) onComplete?.(digits);
    },
    [onChange, onComplete]
  );

  return (
    <TextField
      id="verification_code"
      type="text"
      autoComplete="one-time-code"
      inputMode="numeric"
      fullWidth
      required
      autoFocus
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      error={Boolean(error)}
      helperText={error ?? ' '}
      slotProps={{ htmlInput: { maxLength: OTP_LENGTH, pattern: '[0-9]*' } }}
      sx={{
        '& .MuiInputBase-input': {
          fontSize: '1.875rem',
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
          textAlign: 'center',
          letterSpacing: '0.5em',
          textIndent: '0.5em',
          py: 2,
          color: colors.textPrimary,
        },
      }}
    />
  );
}
